import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../../../../ExperimentContext/types';

export const SuggestionsExperiment = (isSearchOrProfilePage?: boolean) =>
  isSearchOrProfilePage
    ? makeExperimentWithData('new-suggestions', createValidator<undefined | { variant: number }>())
    : null;
